<!-- @format -->
<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  import DropDown from "./DropDown.svelte";

  export let request_store_key: StoresKey;
  export let stores: readonly ManageAPI.Store[];
  export let showAllOption: boolean  = true;

  const dispatch = createEventDispatcher();
  const { scdata, T } = getStoresContext(request_store_key);

  $: floors = $scdata?.floors.filter(
    floor => stores.some(store => store.floor?.id == floor.id)
  ).sort((a,b) => a.order - b.order) || [];

  let select = 0;
  let selectedIndex = 0;
  $: t = $T;

  function changeFloor() {
    dispatch("changeFloor", select);
    dispatch("changeFloorIndex", selectedIndex);
  }
</script>

<DropDown>
  <svelte:fragment slot="default-value">
    {#if select > 0}
      {floors.find((floor) => floor.id == select)?.description}
    {:else if !showAllOption}
      {floors[0]?.description}
    {:else}
      {t`enter floor`}
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="options">
    {#if showAllOption}
      <button
        class="option"
        on:click={() => {
          select = 0;
          selectedIndex = 0;
          changeFloor();
        }}>
        {t`all`}
      </button>
    {/if}
    {#each floors as floor}
      <button
        class="option"
        on:click={() => {
          select = floor.id;
          selectedIndex = floor.order;
          changeFloor();
        }}>
        {floor.description}
      </button>
    {/each}
  </svelte:fragment>
</DropDown>

<style>
  .option {
    display: block;
    background-color: var(--color-white);
    width: 100%;
    border: none;
    padding: 0.25rem 0.5rem;
    text-align: left;
    font-size: 18px;
    color: var(--color-black);

  }
  .option:hover {
    background-color: var(--color-black);
    color: var(--color-white);
  }
</style>
